<template>
  <div>
    <div class="personalisation-header"> {{ $t('device.personalisation.header') }} </div>
    <DevicesListLayout :isActionBarOpen="false">
      <PersonalisationToolbar slot="devices-list-toolbar" />
      <PersonalisationContent
        slot="devices-list"
        :personalisationState="getPersonalisationState"
      />
    </DevicesListLayout>
  </div>
</template>

<script lang="ts">
import { Personalisation as PersonalisationType } from 'ctp-personalisation-search';
import DevicesListLayout from '@/views/Devices/DevicesList/components/DevicesListLayout/DevicesListLayout.vue';
import PersonalisationContent from '@/views/Personalisation/components/PersonalisationContent/PersonalisationContent.vue';
import PersonalisationToolbar from '@/views/Personalisation/components/PersonalisationToolbar/PersonalisationToolbar.vue';
import { INavigation, IPersonalisationState, store } from '@/store/modules/personalisation/types';
import { Component, Vue, Watch } from 'vue-property-decorator';
import './styles/personalisation.scss';
import { MasterAccountInfo } from 'ctp-user-auth-service';
import { store as userStore } from '@/store/modules/user/types';

@Component({
  components: {
    DevicesListLayout,
    PersonalisationContent,
    PersonalisationToolbar
  }
})
export default class Personalisation extends Vue {
  @store.Action
  private fetchFilterPersonalisations! : (configuration: INavigation | void) => PersonalisationType[];

  @store.Getter
  private getPersonalisationState!: IPersonalisationState;

  @store.Getter
  private getNavigationConfiguration!: INavigation;

  @userStore.Getter
  private getSelectedMasterAccount: MasterAccountInfo;

  @store.Action
  private reinit!: () => void;

  private mounted() {
    if (this.$route.params.deviceId) {
      const navigation = this.getNavigationConfiguration;
      navigation.filters = { deviceIds: [this.$route.params.deviceId] };
      this.updateNavigation(navigation);
    }
    this.loadList();
  }

  private destroyed() {
    this.reinit();
  }

  @store.Action
  private updateNavigation!: (payload: INavigation) => void;

  private loadList() {
    this.fetchFilterPersonalisations(this.getNavigationConfiguration);
  }

  @Watch('getNavigationConfiguration', { immediate: true, deep: true })
  private onNavigationChanged() {
    if (!this.getPersonalisationState.loading.personalisationList) {
      this.loadList();
    }
  }

  @Watch('getSelectedMasterAccount', { immediate: true, deep: true })
  private onMasterChange() {
    const account = this.getSelectedMasterAccount;
    if (account.name && !this.getPersonalisationState.loading.personalisationList) {
      this.loadList();
    }
  }
}
</script>
